import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'
import { StatsCard } from 'src/app/constants/stats-cards'

@Component({
  selector: 'app-stats-card',
  templateUrl: './stats-card.component.html',
  styleUrls: ['./stats-card.component.scss']
})
export class StatsCardComponent {
  @Input() statsCard: StatsCard

  constructor(private router: Router) {}

  navigate(statsCard: StatsCard): void {
    if (statsCard.isNavigable && statsCard.linkToNavigate) {
      const [path, queryString] = statsCard.linkToNavigate.split('?')
      const queryParams = this.parseQueryParams(queryString)
      this.router.navigate([path], { queryParams })
    }
  }

  private parseQueryParams(queryString: string): { [key: string]: string } {
    return queryString.split('&').reduce((acc, param) => {
      const [key, value] = param.split('=')
      acc[key] = value
      return acc
    }, {} as { [key: string]: string })
  }
}
